export const constant = {
	selector: {
		target: '.js-grid-stack',
		subTarget: '.grid-stack-sub-grid',
		nestedTarget: '.grid-stack-nested',
		activator: '.js-resize-activator',
		newBlock: '.js-grid-stack-new-block',
		item: '.grid-stack-item',
		headerItem: '.js-grid-stack-item-header',
		footerItem: '.js-grid-stack-item-footer',
		id: 'gs-id',
		width: 'gs-w',
		height: 'gs-h',
		x: 'gs-x',
		y: 'gs-y',
		handler: 'data-grid-stack-id',
		autoHeight: 'data-resize-auto-h',
		floatHandler: '.js-grid-stack-float-handler',
	},
	localStorage: {
		float: 'grid-stack-float',
	},
}
